import {mapGetters} from "vuex";

export const headerTooltipFunctions = {
    data() {
        return {
            dataFieldTooltip: null,
            tooltip: null,
        }
    },
    computed: {
        ...mapGetters('spr', {
            get_spr_data_indicators_loading: 'getIndicatorsStatus',
            get_spr_data_indicators: 'getIndicators',
        }),
        ...mapGetters('checkFilled', {
            organizationBlocked: 'organizationBlocked',
        }),
        disabled(){
            return this.organizationBlocked
        }
    },
    methods:{
        calcHeaderName(name) {
            return 'header-' + name;
        },
        async openTooltip(dataField = '') {
            this.dataFieldTooltip = dataField;
            await this.$refs["tooltip-dialog"].openDialog();
        },
        findInfoForCell(dataField = ''){
            if (this.get_spr_data_indicators && this.get_spr_data_indicators_loading === false){
                return this.get_spr_data_indicators.find(el => el.jsonId === dataField);
            }
        },
    }
}